package navigation.home.messages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.essntl.features.client.ui.addeditclient.AddEditClientEvent
import com.essntl.features.message.ui.client_profile.ClientProfileNavigation
import com.essntl.features.message.ui.client_profile.ClientProfileScreen
import com.essntl.uikit.components.chat.contact.ContactUiState
import navigation.home.clients.addeditclient.AddEditClientScreenModel
import navigation.home.edititinerary.ItineraryServicesListScreen

class ClientProfileScreenNav(
    private val phoneNumber: String,
    private val contactUiState: ContactUiState,
) : Screen {

    @Composable
    override fun Content() {
        val addEditClientScreenModel = koinScreenModel<AddEditClientScreenModel>()
        val addEditClientState by addEditClientScreenModel.state.collectAsState()

        val navigator = LocalNavigator.currentOrThrow

        LaunchedEffect(phoneNumber) {
            addEditClientScreenModel.onEvent(AddEditClientEvent.GetClientByPhoneNumber(phoneNumber))
        }

        ClientProfileScreen(
            state = addEditClientState,
            contactUiState = contactUiState,
            onNavigation = { event ->
                when (event) {
                    is ClientProfileNavigation.NavigateToItinerary -> {
                        navigator.push(
                            ItineraryServicesListScreen(
                                itineraryId = event.itineraryId,
                            ),
                        )
                    }
                }
            },
        )
    }
}